
export enum RatingPartyLocationTypeCd {
	CONSTRUCTION_UTILITY_SITES = 'Construction/UtilitySites',
	EXHIBITION = 'Exhibition',
	GOVERNMENT = 'Government',
	PIERS = 'Piers',
	RESIDENTIAL = 'Residential'}
